var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.smAndUp)?_c('div',{staticClass:"logo-divider",class:{ 'logo-divider-small': _vm.$vuetify.breakpoint.sm || _vm.$vuetify.breakpoint.md }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }